/**
 * Build-time switches for features that exist in the codebase but are not ready for customers.
 *
 * Hiding the entry point is deliberate: the pages and routes stay in the build so the work can carry
 * on and be verified internally by URL, while nothing in the UI leads a customer to a half-finished
 * screen. To release a feature, flip its flag to true and delete nothing else.
 */

/** Job Settings page (per-job digest/followers/automation controls) — backend wiring incomplete. */
export const SHOW_JOB_SETTINGS = false;

/** Job Closure Report page — report content not finalised. */
export const SHOW_JOB_CLOSURE_REPORT = false;

/**
 * Notifications tab in the Account Settings dialog. The preferences save correctly, but nothing
 * consumes them yet — the activity report that acts on the cadence is not released — so the tab
 * would let a customer choose a schedule for email that never arrives.
 */
export const SHOW_NOTIFICATION_PREFERENCES = false;
